/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";

import "./Separator.scss";

export interface ISeparatorProps {
	className?: string;
}

const Separator: React.FC<ISeparatorProps> = ({ className }) => {
	const baseClass = BEM("edt-separator");

	if (className) {
		baseClass.add(className);
	}

	return <hr className={baseClass.toClassName()} />;
};

const SeparatorMemo = React.memo(Separator);

export { SeparatorMemo as Separator };
